import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  applicationVersion: 'if1.9',
  applicationName: 'IndicatorFactoryClient',
  environment: 'PROD',
  isFederal: false,

  // Security
  UseCookies: true,
  StorageID: 'indicator-factory-store',
  AccessTokenID: 'indicator-factory-token',
  TokenIDExpires: 'indicator-factory-token-expires',
  TokenEmail: 'indicator-factory-token-email',
  TokenUserRole: 'indicator-factory-token-role',
  PendoUserID: 'indicator-factory-pendo-userid',
  HospitalId: 'indicator-factory-hospid',
  HospitalName: 'indicator-factory-hospname',
  UserHospId: 'indicator-factory-userhospid',
  UnitId: 'indicator-factory-unitid',
  UnitName: 'indicator-factory-unitname',
  IndicatorId: 'indicator-factory-indid',
  TokenSubscriptionsAvailable: 'indicator-factory-token-subscriptionsavailable',
  SubscriptionSelected: 'indicator-factory-subscription-selected',
  SubscriptionSelectedLocalTest: '1',
  FederationTokenID: 'federation-token',

  Webserver: 'https://members.nursingquality.org',
  LoginPage: 'https://members.nursingquality.org/ndnqiportal/login2/LogIn.aspx?LoggedOut=True',
  EmptyPage: `https://members.nursingquality.org/indicatorfactory/assets/static/empty-page.html`,
  HospitalChangePage: 'https://members.nursingquality.org/ndnqiportal/PortalSession.aspx',
  DisplayDashboardErrorsRefresh: false,
  EnablePendo: true,

  // API's
  Api: 'https://members.nursingquality.org/apis/IndicatorFactoryBusinessApi/api/',
  BusinessApi: 'https://members.nursingquality.org/apis/IndicatorFactoryBusinessApi/api/business/',
  Assets: 'assets/',
  LocalJsonApi: 'assets/json/',
  LocalQuestionsApi: 'assets/json/questions/',
  LocalLayoutsApi: 'assets/json/layouts/',
  LocalTriggersApi: 'assets/json/triggers/',
  LocalSummariesApi: 'assets/json/summaries/',
  FederationBusinessApi: 'https://members.nursingquality.org/apis/ClinicalFederationBusinessApi/api/v1/business', 
  TokenServiceApi: 'https://members.nursingquality.org/apis/NDNQIToken/api',

  // Logging
  LogService: 'https://members.nursingquality.org/apis/CentralizedLoggingAPI/api/log/LogData',
  LogMedia: 'application/pg.centralizedloggingapi.logobject+json',
  LogLevel: NgxLoggerLevel.WARN,
  ServerLogLevel: NgxLoggerLevel.WARN,
  DisableConsoleLogging: true,
  InformationMessages: [ 'hospital demographics have not been verified this quarter',
                         'Data Entry is not allowed' ],
  // Caching
  CacheAge: 600000, // 10 mins
  UseClientCaching: true,
  CachingUrls: [ 'GetIndicatorDetailsOnOff',
                 'GetIndicatorSummaryOnOff',
                 'GetIndicatorHelp',
                 'GetFacilityDeadlines'
               ],

  // Services
  UseBusinessServerForLayouts: false,
  UseBusinessServerForDetailQuestions: true,
  UseBusinessServerForSummaryQuestions: true,
  UseBusinessServerForPeriods: true,
  UseBusinessServerForSummaries: true,
  UseBusinessServerForHelp: true,
  UseBusinessServerForTriggers: true,
  UseBusinessServerForServerValues: true,
  UseBusinessServerForDashboardCalendar: true,
  UseBusinessServerForAssignedLearning: true,
  UseBusinessServerForDataEntryStatus: true,
  UseBusinessServerForDataErrorList: true,
  UseBusinessServerForAvailableHospUnits: false,
  UseBusinessServerForPirEntryPeriods: true,
  UseBusinessServerForTeleconferenceHandouts: true,
  UseBusinessServerForSystemDataEntryStatus: true,
  UseBusinessServerForSystemDataErrorList: true,
  UseBusinessServerForResourceList: true,
  UseBusinessCrossFieldValidators: true,
  UseBusinessServerForSystemExportOptions: true,
  UseBusinessServerForExportActivity: true,
  UseBusinessServerForUnitCsv: true,
  UseBusinessServerForResourceFile: true,
  UseBusinessServerForSiteManagement: true, 
  UseBusinessServerForFacilityExportOptions: true,
  UseBusinessServerForFederation: true,  
  UseBusinessServerForFederationToken: true,

  // Media Types
  GetIndicatorDetailMedia: 'application/pg.indicatorfactorybusinessapi.indicatordetailgetindicatordetail+json',
  SaveIndicatorDetailMedia: 'application/pg.indicatorfactorybusinessapi.indicatordetailsaveindicatordetail+json',
  GetIndicatorDetailsOnOffMedia: 'application/pg.indicatorfactorybusinessapi.indicatordetailgetindicatordetailsonoff+json',
  DeleteIndicatorDetailMedia: 'application/pg.indicatorfactorybusinessapi.indicatordetaildeleteindicatordetail+json',
  GetIndicatorHelpMedia: 'application/pg.indicatorfactorybusinessapi.indicatorhelpgetindicatorhelp+json',
  GetIndicatorPeriodsMedia: 'application/pg.indicatorfactorybusinessapi.indicatorperiodsgetindicatorperiods+json',
  GetIndicatorSummaryMedia: 'application/pg.indicatorfactorybusinessapi.indicatorsummarygetindicatorsummary+json',
  SaveIndicatorSummaryMedia: 'application/pg.indicatorfactorybusinessapi.indicatorsummarysaveindicatorsummary+json',
  GetIndicatorSummaryOnOffMedia: 'application/pg.indicatorfactorybusinessapi.indicatorsummarygetindicatorsummaryonoff+json',
  DeleteIndicatorSummaryMedia: 'application/pg.indicatorfactorybusinessapi.indicatorsummarydeleteindicatorsummary+json',
  GetIndicatorSummariesMedia: 'application/pg.indicatorfactorybusinessapi.indicatorsummarygetindicatorsummaries+json',
  GetPirMedia: 'application/pg.indicatorfactorybusinessapi.pirentryperiodsgetentryperiods+json',
  GetServerValuesMedia: 'application/pg.indicatorfactorybusinessapi.servervaluegetservervalues+json',
  GetDashboardMedia: 'application/pg.indicatorfactorybusinessapi.dashboard+json',
  GetTeleconferenceHandoutsMedia: 'application/pg.indicatorfactorybusinessapi.teleconferencesgetlist+json',
  GetResourceMedia: 'application/pg.indicatorfactorybusinessapi.resourcegetresourcebytypename+json',
  GetCrossFieldValidatorsMedia: 'application/pg.indicatorfactorybusinessapi.indicatorcrossfieldwizard+json',
  GetCrossValidationMedia: 'application/pg.indicatorfactorybusinessapi.crossvalidation+json',
  GetSummaryLayoutMedia: 'application/pg.indicatorfactorybusinessapi.indicatorsummarylayout+json',
  GetDetailLayoutMedia: 'application/pg.indicatorfactorybusinessapi.indicatordetaillayout+json',
  GetSystemExportMedia: 'application/pg.indicatorfactorybusinessapi.GetSystemExport+json',
  GetSystemExportActivityMedia: 'application/pg.indicatorfactorybusinessapi.GetSystemExportLog+json',
  GetSystemExportFileMedia: 'application/pg.indicatorfactorybusinessapi.getzippedfilefromdb+json',
  RequestSystemExportFileMedia: 'application/pg.indicatorfactorybusinessapi.requestexport+json',
  GetUsersMedia: 'application/pg.indicatorfactorybusinessapi.getusers+json',
  GetUserRoleMedia: 'application/pg.indicatorfactorybusinessapi.getroleslu+json',
  GetMainMenuAccessMedia: 'application/pg.indicatorfactorybusinessapi.getmainmenuaccess+json', 
  GetDataEntryAccessMedia:  'application/pg.indicatorfactorybusinessapi.getdataentryaccess+json',
  DeleteUserMedia: 'application/pg.indicatorfactorybusinessapi.deleteuser+json',
  UpdateUserMedia: 'application/pg.indicatorfactorybusinessapi.updateuser+json',
  UpdateMenuMedia: 'application/pg.indicatorfactorybusinessapi.UpdateMainMenuAccess+json',
  UpdateDataEntryMedia: 'application/pg.indicatorfactorybusinessapi.UpdateDataEntryAccess+json',
  GetUnitCsvMedia: 'application/pg.indicatorfactorybusinessapi.getunitscsv+json',
  GetResourceFile: 'application/pg.indicatorfactorybusinessapi.getresourcefile+json',

  GetFacilityExportMedia: 'application/pg.indicatorfactorybusinessapi.GetFacilityExport+json',
  GetFacilityExportActivityMedia: 'application/pg.indicatorfactorybusinessapi.GetFacilityExportLog+json',
  GetFacilityExportFileMedia: 'application/pg.indicatorfactorybusinessapi.getzippedfilefromdb+json',
  RequestFacilityExportFileMedia: 'application/pg.indicatorfactorybusinessapi.requestexport+json',

  // New Pressure Injuries and Restraints
  PressureInjuriesAndRestrainstsIndicatorId: 75,
  PressureInjuriesIndicatorId: 74,
  RestraintsIndicatorId: 73,
  // Old Pressure Injuries and Restraints
  PressureInjuriesAndRestrainstsIndicatorId2: 72,
  PressureInjuriesIndicatorId2: 66,
  RestraintsIndicatorId2: 65,

  CrossFieldValidationPostSubmit: [79, 78, 75, 74, 73]
};
